import { useContext } from 'react';

import { Box, MenuItem } from '@mui/material';

import { defaultPalette } from '@/theme';

import { ActionsMenuContext } from './context';
import { ActionsMenuItemProps } from './types';

function ActionsMenuItem({
  testId,
  icon,
  destructive,
  onClick,
  children,
  disabled = false,
  waitForClick = false,
}: ActionsMenuItemProps) {
  const context = useContext(ActionsMenuContext);

  async function handleClick() {
    if (waitForClick) {
      await onClick();
    }

    context.closeMenu();

    if (!waitForClick) {
      await onClick();
    }
  }

  return (
    <MenuItem
      data-cy={testId}
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 1,
        ...(destructive && { color: defaultPalette.error.main }),
      }}
      onClick={handleClick}
      disabled={disabled}
    >
      {icon}
      <Box flex={1}>{children}</Box>
    </MenuItem>
  );
}

export default ActionsMenuItem;
